{
  "en": {
    "add": "Add",
    "annexe": "This section is an Annexe",
    "aso": "Aso",
    "cancel": "Cancel",
    "path": "Section path",
    "conditionalTitles": "Conditional Titles",
    "conditionalDisplay": "Conditional Display",
    "confirm": "Confirm",
    "description": "Description",
    "fieldRequired": "This field is required",
    "editSection": "Edit Section",
    "expertComment": "Expert comment",
    "filteredMissionsDestTypes": "Filtered according to parent heading",
    "label": "Label",
    "newTitle": "New title [edit me]",
    "pathology": "Pathology",
    "pm": "PM",
    "regulationDocuments": "Regulation Documents",
    "qualityIndexes": "Quality indexes",
    "rpp": "RPP",
    "saveSuccess": "Section saved",
    "sectionPamphlets": "Pamphlets",
    "templateSentences": "Template Sentences",
    "sectionMissions": "Missions",
    "sectionPamphletHelp": "The pamphlet's code is on the top right of the document",
    "sectionDestinations": "Destinations",
    "sectionTypes": "Types",
    "update": "Update",
    "updateChildrenMissions": "Children's missions",
    "updateChildrenDestinations": "Children's destinations",
    "updateChildrenTypes": "Types of children",
    "positiveNumberRequired": "This number must be positive",
    "editDisplay": "Editer display condition of section {section}",
    "editTitle": "Edit title of section {section}",
    "technicalDoc": "Technical documentation",
    "rapsotecNodePamphlets": "Pamphlets",
    "reference": "Reference"
  },
  "fr": {
    "add": "Ajouter",
    "annexe": "Cette rubrique est une Annexe",
    "aso": "ASO",
    "cancel": "Annuler",
    "path": "Chemin de rubrique",
    "conditionalTitles": "Variable de titre",
    "conditionalDisplay": "Variable d'affichage",
    "confirm": "Valider",
    "description": "Libellé long",
    "fieldRequired": "Ce champs est requis",
    "editSection": "Modifier la rubrique",
    "expertComment": "Commentaire de l'expert",
    "filteredMissionsDestTypes": "Filtrées en fonction de la rubrique parente",
    "label": "Libellé court",
    "newTitle": "Nouveau titre [changez-moi]",
    "pathology": "Pathologie",
    "pm": "PM",
    "regulationDocuments": "Articles de réglement",
    "qualityIndexes": "Indices de qualité",
    "rpp": "RPP",
    "saveSuccess": "Rubrique sauvegardée",
    "sectionPamphlets": "Bibliographie IRIS",
    "templateSentences": "Phrase type",
    "sectionMissions": "Missions",
    "sectionPamphletHelp": "Le code du fascicule se trouve en haut à droite du document",
    "sectionDestinations": "Destinations",
    "sectionTypes": "Types",
    "update": "Mise à jour",
    "updateChildrenMissions": "Missions des enfants",
    "updateChildrenDestinations": "Destinations des enfants",
    "positiveNumberRequired": "Le numéro doit être positif",
    "editDisplay": "Editer conditions affichage rubrique {section}",
    "editTitle": "Editer le titre de la rubrique {section}",
    "code": "Numéro de rubrique",
    "updateChildrenTypes": "Types des enfants",
    "technicalDoc": "Documentation technique",
    "rapsotecNodePamphlets": "Bibliographie IRIS",
    "reference": "Référence"
  },
  "nl": {
    "add": "Voeg  toe",
    "annexe": "Dit deel is een aanhangsel",
    "aso": "ASO",
    "cancel": "Annuleren",
    "path": "Onderwerp pad",
    "conditionalTitles": "Titelvariabele",
    "conditionalDisplay": "Variabele weergave",
    "confirm": "Bevestigen",
    "description": "Lange tekst",
    "fieldRequired": "Dit veld is verplicht",
    "editSection": "Wijzig het item",
    "expertComment": "Commentaar van de expert",
    "filteredMissionsDestTypes": "Gefilterd op hoofdrubriek",
    "label": "Korte tekst",
    "newTitle": "Nieuwe titel [verander mij]",
    "pathology": "Pathologie",
    "pm": "PM",
    "regulationDocuments": "Artikelen van de verordening",
    "qualityIndexes": "kwaliteitsindicatoren",
    "rpp": "RPP",
    "saveSuccess": "Opgeslagen sectie",
    "sectionPamphlets": "IRIS Bibliografie",
    "templateSentences": "Standaard zin",
    "sectionMissions": "Opdrachten",
    "sectionPamphletHelp": "De code van het artikel staat rechtsboven in het document.",
    "sectionDestinations": "Bestemmingen",
    "sectionTypes": "Types",
    "update": "Update",
    "updateChildrenMissions": "Kindermissies",
    "updateChildrenDestinations": "Bestemmingen voor kinderen",
    "positiveNumberRequired": "Het getal moet positief zijn",
    "editDisplay": "Bewerk de weergavevoorwaarden van de sectie {sectie}",
    "editTitle": "Bewerk de titel van de sectie {section}",
    "code": "Sectienummer",
    "updateChildrenTypes": "Soorten kinderen",
    "technicalDoc": "Technische documentatie",
    "rapsotecNodePamphlets": "Pamphlets",
    "reference": "Referentie"
  }
}
